export const PuppyClips = {
A_Pose: 0,
Attack_Bite: 1,
Attack_F: 2,
Attack_L: 3,
Attack_R: 4,
Crouch_B_RM: 5,
Crouch_BL_RM: 6,
Crouch_BR_RM: 7,
Crouch_F_RM: 8,
Crouch_Idle_end: 9,
Crouch_Idle_loop: 10,
Crouch_Idle_start: 11,
Crouch_L_RM: 12,
Crouch_R_RM: 13,
Crouch_turn_L_RM: 14,
Crouch_turn_R_RM: 15,
Death_L: 16,
Death_R: 17,
Digging_end: 18,
Digging_loop: 19,
Digging_start: 20,
Drink_loop: 21,
Eat_loop: 22,
EatDrink_end: 23,
EatDrink_start: 24,
Fall: 25,
Fall_start_RM: 26,
Hit_B: 27,
Hit_F: 28,
Hit_M: 29,
Idle_1: 30,
Idle_2: 31,
Idle_3: 32,
Idle_4: 33,
Idle_5_end: 34,
Idle_5_loop: 35,
Idle_5_start: 36,
Idle_6: 37,
Jump_down_high: 38,
Jump_down_low: 39,
Jump_hor: 40,
Jump_Inplace_end: 41,
Jump_Inplace_Full: 42,
Jump_Inplace_start: 43,
Jump_land_RM: 44,
Jump_start_RM: 45,
Jump_up: 46,
Lie_end: 47,
Lie_loop_1: 48,
Lie_loop_2: 49,
Lie_Sleep_end: 50,
Lie_Sleep_loop: 51,
Lie_Sleep_start: 52,
Lie_start: 53,
Pissing: 54,
Run_F_RM: 55,
Run_L_RM: 56,
Run_R_RM: 57,
Sitting_end: 58,
Sitting_loop_1: 59,
Sitting_loop_2: 60,
Sitting_start: 61,
Swim_B_RM: 62,
Swim_BL_RM: 63,
Swim_BR_RM: 64,
Swim_enter_RM: 65,
Swim_F_RM: 66,
Swim_idle: 67,
Swim_L_RM: 68,
Swim_R_RM: 69,
Swim_Turn_L_RM: 70,
Swim_Turn_R_RM: 71,
Trot_F_RM: 72,
Trot_L_RM: 73,
Trot_R_RM: 74,
Turn_L_RM: 75,
Turn_R_RM: 76,
Walk_B_RM: 77,
Walk_BL_RM: 78,
Walk_BR_RM: 79,
Walk_F_RM: 80,
Walk_L_RM: 81,
Walk_R_RM: 82,
} as const;

export type PuppyClipName = keyof typeof PuppyClips;
export type PuppyClipId = (typeof PuppyClips)[PuppyClipName];